import React from 'react';
import AppRoutes from './routes/index';


function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
